// Libraries
import React, { Component } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import GoogleMap from "./googleMap";

// Child Components
import { PoiCategory, TagsList } from "../poiDisplayComponents";
import * as utils from "../misc/utils";

// Config
import { mapStyle } from "../../../utils/scripts/map";

// Constants
const googleMapKey = process.env.REACT_APP_GOOGLE_MAP_KEY;
const baseUrl = process.env.REACT_APP_API_URL;

function mapViewUrlPathWithLanguage(lang) {
  return lang === "de"
    ? `/gallery/?view=map&`
    : `/gallery/?lang=${lang}&view=map&`;
}

function categoryHTML(category, lang, noSelTC) {
  return renderToStaticMarkup(
    <PoiCategory
      category={category}
      lang={lang}
      linkBaseUrl={mapViewUrlPathWithLanguage(lang)}
      noSelTC={noSelTC}
    />
  );
}

function tagListHTML(tags, lang, noSelTC) {
  return renderToStaticMarkup(
    <TagsList
      tags={tags}
      lang={lang}
      linkBaseUrl={mapViewUrlPathWithLanguage(lang)}
      noSelTC={noSelTC}
    />
  );
}

class MapView extends Component {
  state = {
    queryParams: null,
    noSelTC: false,
  };

  constructor(props) {
    super(props);
    this.state.queryParams = this.props.queryParams;
    this.state.noSelTC = this.props.noSelTC;
  }

  getInfoWindowString = (poi, lang, queryParams, noSelTC) => {
    const additionalQueryParamsString = queryParams
      ? // filter out any existing id query as we'll introduce our own
        utils.selectQueriesExcept(queryParams, ["id"]).toString()
      : "";

    return `
      <div class="card border-0" style="max-width: 280px;">
      <h5 >${lang === "de" ? poi.title_de : poi.title_en}</h5>
      <small><p class="">${lang === "de" ? "Kategorie" : "Category"}:
          ${categoryHTML(poi.category, lang, noSelTC)}
      </p></small>
      <img class="card-img-bottom" src=${baseUrl}/pois/${poi._id}/${
      poi.filename
    } alt="${
      poi.title_en
    }" style="max-width: 256px; max-height: 512px; width: auto; height: auto;">
      <small class="text-muted mt-1">${
        lang === "de" ? poi.caption_de : poi.caption_en
      }</small>
      <p class="card-text mt-3">${
        lang === "de" ? poi.description_de : poi.description_en
      }</p>
      <small><p class="mt-1">Tags:
          ${tagListHTML(poi.tags, lang, noSelTC)}
      </span></p>
      </small>
      <a class="btn btn-sm btn-outline-primary rounded mt-1" href="?id=${
        poi._id + utils.smartPrepend("&", additionalQueryParamsString)
      }">${lang === "de" ? "Weiterlesen" : "Read More"}</a>
      </div>`;
  };

  handleApiLoaded = (map, maps, pois, lang) => {
    const markers = [];
    const infowindows = [];

    pois.forEach((poi) => {
      markers.push(
        new maps.Marker({
          position: {
            lat: poi.lat,
            lng: poi.long,
          },
          map,
          title: poi.title_en,
          label: "●", //poi.title_en[0],
          // labelClass: "labels", // the CSS class for the label
        })
      );

      infowindows.push(
        new maps.InfoWindow({
          content: this.getInfoWindowString(
            poi,
            lang,
            this.state.queryParams,
            this.state.noSelTC
          ),
        })
      );
    });

    markers.forEach((marker, i) => {
      marker.addListener("click", () => {
        infowindows[i].open(map, marker);
      });
    });
  };

  // Recenter and Zoom Function
  getMapReCenter = (pois) => {
    // Get Map Center
    let avg_lat = 0;
    let avg_long = 0;
    for (const poi of pois) {
      avg_lat += poi.lat;
      avg_long += poi.long;
    }

    // New center of Zoom chaning
    const center_lat = avg_lat / pois.length;
    const center_long = avg_long / pois.length;
    const center = [center_lat, center_long];

    // Amount of Zoom Changing
    const maxLat = Math.max.apply(
      Math,
      pois.map(function (p) {
        return p.lat;
      })
    );
    const minLat = Math.min.apply(
      Math,
      pois.map(function (p) {
        return p.lat;
      })
    );
    const maxLong = Math.max.apply(
      Math,
      pois.map(function (p) {
        return p.long;
      })
    );
    const minLong = Math.min.apply(
      Math,
      pois.map(function (p) {
        return p.long;
      })
    );
    const zoomFactor = (maxLat - minLat + maxLong - minLong) * 100;
    const zoom = 15 - Math.round(zoomFactor / 3);

    return {
      center,
      zoom,
    };
  };

  render() {
    function createMapOptions(maps) {
      return {
        zoomControlOptions: {
          position: maps.ControlPosition.RIGHT_BOTTOM,
        },
        streetViewControlOptions: {
          position: maps.ControlPosition.RIGHT_TOP,
        },
        mapTypeControl: false,
        streetViewControl: true,
        styles: mapStyle,
        rotateControl: true,
        fullscreenControl: false,
        scrollwheel: true,
        disableDoubleClickZoom: true,
      };
    }

    // Get Map Center and Zoom
    const { style, pois: data, lang } = this.props;
    // Remove pois that doesn't have location
    const pois = data.filter((p) => p.has_histocache_location === true);
    const { center, zoom } = this.getMapReCenter(pois);

    return (
      <GoogleMap
        bootstrapURLKeys={{
          key: googleMapKey,
        }}
        defaultCenter={center}
        defaultZoom={zoom}
        options={createMapOptions}
        style={style}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={({ map, maps }) =>
          this.handleApiLoaded(map, maps, pois, lang)
        }
      />
    );
  }
}

export default MapView;

/*
<div style={style}>
        <GoogleMapReact
          bootstrapURLKeys={{
            key: googleMapKey,
          }}
          defaultCenter={center}
          defaultZoom={zoom}
          options={createMapOptions}
        >
          {pois.map((p) =>
            marker === "icon" ? (
              <i
                className="bx bxs-map bx-md map-pin"
                lat={p.lat}
                lng={p.long}
                onClick={onClick}
                onMouseDown={onMouseDown}
              ></i>
            ) : (
              <div
                className="map-tick"
                key={p._id}
                lat={p.lat}
                lng={p.long}
                onClick={onClick}
                onMouseDown={onMouseDown}
              >
                <div className="map-box" key={p.priority}>
                  {p.name}
                </div>
              </div>
            )
          )}
        </GoogleMapReact>
      </div>
*/
